import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import ConfidenceIndicator from './ConfidenceIndicator';

const LinearDataCell = ({ column, value }) => (
  <TableCell key={column.id} align={column.align} style={{ textAlign: 'center' }}>
    <ConfidenceIndicator value={column.render(value)} />
  </TableCell>
);

export default LinearDataCell;
